import {
  useAssessmentsQuery,
  AssessmentsQueryVariables,
} from "@/features/assessments/graphql/generated";
import { useAccount } from "@/features/workspace/hooks/useAccount";

export const useAssessmentsList = (params: AssessmentsQueryVariables) => {
  const { data, loading } = useAssessmentsQuery({
    variables: params,
    fetchPolicy: "cache-and-network",
  });

  const assessments = data?.assessments || [];

  return {
    assessments,
    loading,
  };
};
